import { Square } from 'lucide-react';
import type { SectionBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const sectionConfig: BlockTypeConfig<SectionBlock> = {
  type: 'section',
  label: 'Section',
  description: 'Groups blocks with background and width control',
  icon: Square,
  category: 'layout',
  createDefault: () => ({
    blocks: [],
    background: 'none',
    backgroundWidth: 'full',
    contentWidth: 'default',
    padding: 'md',
  }),
  toolbar: [
    { kind: 'section-background' },
    {
      kind: 'select',
      path: 'data.padding',
      label: 'Padding',
      options: [
        { value: 'none', label: 'None' },
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
        { value: 'xl', label: 'Extra Large' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [
    {
      kind: 'select',
      path: 'data.backgroundWidth',
      label: 'Background width',
      options: [
        { value: 'full', label: 'Full' },
        { value: 'container', label: 'Container' },
      ],
    },
    {
      kind: 'select',
      path: 'data.contentWidth',
      label: 'Content width',
      options: [
        { value: 'narrow', label: 'Narrow' },
        { value: 'default', label: 'Default' },
        { value: 'wide', label: 'Wide' },
        { value: 'full', label: 'Full' },
      ],
    },
    {
      kind: 'select',
      path: 'data.textColor',
      label: 'Text color',
      options: [
        { value: 'default', label: 'Default' },
        { value: 'light', label: 'Light' },
        { value: 'dark', label: 'Dark' },
      ],
    },
  ],
  variants: [
    {
      id: 'default',
      label: 'Default',
      thumbnail: '/admin/page-editor/variants/section-default.svg',
      apply: (d) => ({ ...d, variant: 'default' }),
    },
    {
      id: 'gradient-mesh',
      label: 'Gradient mesh',
      thumbnail: '/admin/page-editor/variants/section-gradient-mesh.svg',
      apply: (d) => ({
        ...d,
        variant: 'gradient-mesh',
        textColor: 'light' as const,
        padding: 'lg' as const,
        meshColors: ['#7c3aed', '#06b6d4', '#f59e0b'],
      }),
    },
    {
      id: 'video-bg',
      label: 'Video background',
      thumbnail: '/admin/page-editor/variants/section-video-bg.svg',
      apply: (d) => ({
        ...d,
        variant: 'video-bg',
        textColor: 'light' as const,
        padding: 'xl' as const,
      }),
    },
    {
      id: 'diagonal-mask',
      label: 'Diagonal mask',
      thumbnail: '/admin/page-editor/variants/section-diagonal-mask.svg',
      apply: (d) => ({ ...d, variant: 'diagonal-mask' }),
    },
  ],
  container: {
    childPaths: ['data.blocks'],
  },
};
